const URL = {
  SOURCE_TEXT: 'source-text',
}

export default URL
